export const ENDPOINT = "http://127.0.0.1:5000"

export const LOGIN_URL = `${ENDPOINT}/login`
export const REGISTER_URL = `${ENDPOINT}/register`
export const CREATE_AUDIT_URL = `${ENDPOINT}/create-audit`
export const UPDATE_AUDIT_URL = `${ENDPOINT}/update-audit`
export const GET_AUDITS_PROGRESS_URL = `${ENDPOINT}/get-audits-by-user`
export const GET_AUDIT_DETAIL_URL = `${ENDPOINT}/get-audit-by-id`
